import { config } from "@/config";
export class ProductoService {
    static async getAllProductos() {
        const response = await fetch(`${config.API_URL}/api/Producto`);
        if (!response.ok) {
            throw new Error("Error al obtener productos");
        }
        return response.json();
    }
    static async getAllProductosDashboard() {
        const response = await fetch(`${config.API_URL}/api/Producto/limit`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            throw new Error("Error al obtener productos");
        }
        return response.json();
    }
    static async getProductosSearch(searchText) {
        const response = await fetch(`${config.API_URL}/api/Producto/search?searchTerm=${encodeURIComponent(searchText)}`);
        if (!response.ok) {
            throw new Error("Error al obtener productos");
        }
        return await response.json(); // Asegúrate de que la API devuelve un array de productos
    }
    static async getProductoById(id) {
        const response = await fetch(`${config.API_URL}/api/Producto/${id}`);
        if (!response.ok) {
            throw new Error("Error al obtener producto");
        }
        return response.json();
    }
    static async getProductosFiltrados(filtros) {
        const queryParams = new URLSearchParams(filtros).toString();
        const response = await fetch(`${config.API_URL}/api/Producto/filtrar?${queryParams}`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        });
        if (!response.ok) {
            throw new Error("Error al obtener productos con filtros");
        }
        return response.json();
    }
    static async addProducto(formData) {
        try {
            // Verifica nuevamente si se eliminó
            formData.forEach((value, key) => {
                console.log(key, value); // Verificar que se haya eliminado
            });
            // Enviar el FormData a la API
            const response = await fetch(`${config.API_URL}/api/Producto/agregar`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                },
                body: formData,
            });
            // Verificar si la respuesta es exitosa
            if (!response.ok) {
                throw new Error("Error al agregar producto con imágenes");
            }
            // Opcional: Maneja la respuesta, si es necesario
            const data = await response.json();
            console.log("Producto agregado con éxito:", data);
            return data;
        }
        catch (error) {
            console.error("Error en la solicitud:", error);
        }
    }
    static async updateProducto(id, formData) {
        try {
            const response = await fetch(`${config.API_URL}/api/Producto/${id}`, {
                method: "PUT",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                },
                body: formData,
            });
            if (!response.ok) {
                throw new Error("Error al actualizar producto");
            }
            // Si es 204 NoContent, devolver un objeto indicando éxito en lugar de intentar parsear JSON
            if (response.status === 204) {
                return { exito: true };
            }
            return await response.json();
        }
        catch (error) {
            console.error("Error en updateProducto:", error);
            throw error;
        }
    }
    static async deleteProducto(id) {
        const response = await fetch(`${config.API_URL}/api/Producto/${id}`, {
            method: "DELETE",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
            },
        });
        if (!response.ok) {
            throw new Error("Error al eliminar producto");
        }
    }
    // Método para activar o desactivar un producto
    static async toggleEstadoProducto(id) {
        const response = await fetch(`${config.API_URL}/api/Producto/estado/${id}`, {
            method: "PUT",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            throw new Error("Error al cambiar el estado del producto");
        }
        // Opcional: Maneja la respuesta, si es necesario
        const data = await response.json();
        return data;
    }
}
